var map = {
	"./ages/adult.svg": 613,
	"./ages/old.svg": 614,
	"./ages/teen.svg": 615,
	"./ages/young.svg": 616,
	"./astronaut.svg": 617,
	"./error.svg": 618,
	"./marked-tag.svg": 327,
	"./no-data.svg": 329,
	"./rock.svg": 328,
	"./test_export.jpg": 619,
	"./verified.png": 574,
	"./wave.svg": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1063;